import { memo } from "react";
import styled from "styled-components";
import deleteImg from "assets/icons/common/TableDelete.svg";
import editImg from "assets/icons/common/TableEdit.svg";
import Details from "assets/icons/common/TableView.svg";
import { Dropdown, Menu, Tooltip } from "antd";
import Call from "assets/icons/common/TableCall.svg";
import { useSelector } from "react-redux";
import _ from "lodash";
// import { PushpinOutlined, CloseOutlined } from "@ant-design/icons";

const Action = (props, ref) => {
  const { fieldsMappingCallCenter, objectsToCall } = useSelector(
    (state) => state.callCenterReducer
  );

  return (
    <ActionWrap>
      {!window.location.pathname.includes("token-management") &&
        !props.ListHiddenAction.includes("callAction") &&
        Object.keys(fieldsMappingCallCenter).length > 0 &&
        fieldsMappingCallCenter.phone_fields.length > 0 && (
          <Dropdown
            overlay={
              <Menu>
                {fieldsMappingCallCenter.phone_fields.map((item) => (
                  <>
                    {Object.entries(_.get(props, "data")).map(
                      ([keyRecord, valRecord]) => {
                        return (
                          <>
                            {item === keyRecord && valRecord && (
                              <>
                                {fieldsMappingCallCenter.custom_hotlines
                                  .length > 0 ? (
                                  <>
                                    {fieldsMappingCallCenter.custom_hotlines.map(
                                      (hotline) => {
                                        return (
                                          <Menu.Item
                                            onClick={() =>
                                              props._onMakeCall(
                                                valRecord,
                                                hotline.hotline,
                                                _.get(props, "data._id")
                                              )
                                            }
                                            key={valRecord}
                                          >
                                            {hotline.prefix}
                                            {valRecord}
                                          </Menu.Item>
                                        );
                                      }
                                    )}
                                  </>
                                ) : (
                                  <Menu.Item
                                    onClick={() =>
                                      props._onMakeCall(
                                        valRecord,
                                        "",
                                        _.get(props, "data._id")
                                      )
                                    }
                                    key={valRecord}
                                  >
                                    {valRecord}
                                  </Menu.Item>
                                )}
                              </>
                            )}
                          </>
                        );
                      }
                    )}
                  </>
                ))}
              </Menu>
            }
            placement="bottom"
          >
            <img
              src={Call}
              alt="call"
              style={{ height: "16px", objectFit: "cover" }}
            />
          </Dropdown>
        )}

      {!window.location.pathname.includes("token-management") &&
        !props.ListHiddenAction.includes("callAction") &&
        Object.keys(objectsToCall).length > 0 &&
        _.get(objectsToCall, "phone_fields", [])?.length > 0 && (
          <Dropdown
            overlay={
              <Menu>
                {_.get(objectsToCall, "phone_fields", [])?.map((item) => (
                  <>
                    {Object.entries(_.get(props, "data")).map(
                      ([keyRecord, valRecord]) => {
                        return (
                          <>
                            {item === keyRecord && valRecord && (
                              <>
                                {_.get(objectsToCall, "custom_hotlines", [])
                                  .length > 0 ? (
                                  <>
                                    {_.get(
                                      objectsToCall,
                                      "custom_hotlines",
                                      []
                                    ).map((hotline) => {
                                      return (
                                        <Menu.Item
                                          onClick={() =>
                                            props._onMakeCall(
                                              valRecord,
                                              hotline.hotline,
                                              _.get(props, "data._id")
                                            )
                                          }
                                          key={valRecord}
                                        >
                                          {hotline.prefix}
                                          {valRecord}
                                        </Menu.Item>
                                      );
                                    })}
                                  </>
                                ) : (
                                  <Menu.Item
                                    onClick={() =>
                                      props._onMakeCall(
                                        valRecord,
                                        "",
                                        _.get(props, "data._id")
                                      )
                                    }
                                    key={valRecord}
                                  >
                                    {valRecord}
                                  </Menu.Item>
                                )}
                              </>
                            )}
                          </>
                        );
                      }
                    )}
                  </>
                ))}
              </Menu>
            }
            placement="bottom"
          >
            <img src={Call} alt="call" />
          </Dropdown>
        )}

      {/* <Tooltip title="Pin row">
        {_.get(props, "node.rowPinned") === "top" ? (
          <CloseOutlined
            style={{ fontSize: 16 }}
            onClick={() => {
              props.setPinnedRows((pre) =>
                pre.filter((item) => item._id !== _.get(props, "data._id"))
              );

              console.log({
                add: _.get(props, "data"),
                addIndex: _.get(props, "data.oldIndex"),
              });

              const rowData = [];
              props.gridRef.current.api.forEachNode(function (node) {
                rowData.push(node.data);
              });
              console.log("Row Data:", rowData);

              // props.gridRef.current.api.applyTransaction({
              //   add: [_.get(props, "data")],
              //   addIndex: _.get(props, "data.oldIndex"),
              // });
            }}
          />
        ) : (
          <PushpinOutlined
            style={{ fontSize: 16 }}
            onClick={() => {
              props.setPinnedRows((pre) =>
                pre.concat({
                  ..._.get(props, "data"),
                  oldIndex: _.get(props, "rowIndex"),
                })
              );
              // props.gridRef.current.api.applyTransaction({
              //   remove: [_.get(props, "data")],
              // });

              console.log(props);
            }}
          />
        )}
      </Tooltip> */}
      {!props.ListHiddenAction.includes("view") && (
        <Tooltip title="Consolidate view">
          <img
            style={{ height: "16px", objectFit: "cover" }}
            src={Details}
            alt="Consolidate view"
            onClick={() => {
              props.handleViewRecord &&
                props.handleViewRecord(_.get(props, "data._id"));
            }}
          />
        </Tooltip>
      )}
      {!props.ListHiddenAction.includes("edit") && (
        <Tooltip title="Edit">
          <img
            style={{ height: "16px", objectFit: "cover" }}
            src={editImg}
            alt="Edit"
            onClick={() => {
              props.handleEditRecord && props.handleEditRecord(props.data);
            }}
          />
        </Tooltip>
      )}
      {!props.ListHiddenAction.includes("delete") && (
        <Tooltip title="Delete">
          <img
            style={{ height: "16px", objectFit: "cover" }}
            src={deleteImg}
            alt="Delete"
            onClick={() => {
              props.handleDeleteRecord && props.handleDeleteRecord(props.data);
            }}
          />
        </Tooltip>
      )}
    </ActionWrap>
  );
};

export default memo(Action);

const ActionWrap = styled.span`
  width: 100%;
  margin: auto;

  img {
    margin: 0 4px;
    width: 18px;
    &:hover {
      cursor: pointer;
    }
  }
`;
